import { COLORS, FONTS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  root: {
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARK,
  },
  suggestionsContainer: {
    border: `1px solid ${COLORS.GREY}`,
    borderTop: 'none',
    borderBottom: 'none',
  },
  suggestionItem: {
    cursor: 'pointer',
    padding: '8px 10px',
    borderBottom: `1px solid ${COLORS.GREY}`,
  },
  suggestionItemActive: {
    backgroundColor: COLORS.GREY,
  },
  input: {
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
  label: {
    fontWeight: '400',
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
  },
  labelFocused: {
    fontWeight: '600',
    fontSize: '1rem',
  },
  labelShrink: {
    fontWeight: '600',
    fontSize: '1rem',
    color: COLORS.BLACK,
  },
});

export default styles;
